<div class="no-packages-container">
  <div class="no-packages-content">
    <h2 class="no-packages-title">No packages to show</h2>
    <p class="no-packages-description">Create wash packages to proceed with creating an order.</p>
    <button class="add-package-btn" *ngIf="isAdmin()" (click)="onAddPackage()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 4V16M4 10H16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Add Package
    </button>
  </div>
</div>
